import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicMultiplication extends DesigntimeComponent {
    static staticName = "Logic: Multiplication";
    static staticId = "logicMultiplication";
    hasRuntimeView = false;

    selectedOutputs = [];
    selectedValues = {};

    constructor(identifyer) {
        super(identifyer, 1);
        this.values = {};
    }

    getDesignerView(outputs) {
        var $designerView = DesigntimeComponent.prototype.getDesignerView.call(this, outputs);

        for (var outputIndex in outputs) {
            if (outputs[outputIndex].id == this.id)
                continue;

            var output = outputs[outputIndex];

            var uniqueId = this.id + "_input_" + output;

            var $formcheck = $("<div class='form-check'></div>")

            var $checkbox = $("<input id='" + uniqueId + "'class='form-check-input' type='checkbox' data-key='" + output.key + "'>");
            if (this.selectedOutputs.includes(output.key)) {
                $checkbox.prop("checked", true);
            }

            $checkbox.change(function (e) {
                var clickedKey = $(e.currentTarget).data("key");
                var checked = $(e.currentTarget).prop("checked");
                if (checked) {
                    this.selectedOutputs.push(clickedKey);
                } else {
                    this.selectedOutputs = componentHelpers.arrayRemove(this.selectedOutputs, clickedKey);
                }
            }.bind(this));
            var $label = $("<label class='form-check-label' for='" + uniqueId + "'>" + output.key + "</label>");
            $formcheck.append($checkbox);
            $formcheck.append($label);
            $designerView.append($formcheck);
        }

        return $designerView;
    }

    getRuntimeView(context) {
        for (var valueIndex in this.selectedValues) {
            this.selectedValues[valueIndex] = 0;
        }

        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;
        if (!this.selectedOutputs.includes(eventParams.key))
            return;

        this.selectedValues[eventParams.key] = eventParams.value;

        var product = 1;

        for (var valueIndex in this.selectedValues) {
            product = product * this.selectedValues[valueIndex];
        }

        this.eventBroker.fireValueChanged(this.id, "product", product);

    }

    importModel(model) {
        super.importModel(model);
        this.selectedOutputs = model.selectedOutputs;
    };

    exportModel() {
        var res = super.exportModel()
        res.selectedOutputs = this.selectedOutputs;
        return res;
    }

    output = [
        { name: "product", type: "number" }
    ];
}

export { LogicMultiplication }
